import { useNavigate } from 'react-router-dom';
import { ArrowRight, Award, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import airport from '@/assets/home-airport.jpg';
import passport from '@/assets/home-passport.jpg';
import packing from '@/assets/home-packing.jpg';
import lisbon from '@/assets/home-lisbon.jpg';

export const InteractiveHero = () => {
  const navigate = useNavigate();
  return (
    <section className="home-opening home-container" aria-label="OdyVoy travel preparation">
      <div className="home-opening-copy">
        <p className="home-eyebrow">Your personal travel-preparation companion</p>
        <div className="home-brand-lockup" aria-hidden="true">
          <img src="/lovable-uploads/odyvoy-icon.png" alt="" width={72} height={72} className="home-brand-icon" />
          <div>
            <p className="home-brand-name">OdyVoy</p>
            <p className="home-brand-tagline">Your Odyssey. Our Voyage!</p>
          </div>
        </div>
        <h1 className="home-opening-heading"><span className="sr-only">OdyVoy: </span>Everything to check.<br /><span className="text-primary">Before you go.</span></h1>
        <p className="home-opening-description">A packing list that fits your trip. Visa rules for your passport. Weather, health, jet lag, money and <br className="hidden md:block" />local know-how. Your destination and dates <br className="hidden md:block" />bring it all together.</p>
        <div className="home-hero-actions">
          <Button onClick={() => navigate('/auth')} className="home-primary-action">Prepare me for my trip - free <ArrowRight aria-hidden="true" /></Button>
          <Button variant="ghost" className="home-secondary-action" onClick={() => document.getElementById('try-it')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })}><Play aria-hidden="true" /> Explore a trip</Button>
        </div>
        <div className="home-credentials">
          <div><p className="home-small-label">Commitment</p><p className="font-semibold">No credit card</p></div>
          <div className="border-l border-border pl-6"><p className="home-small-label">Recognition</p><p className="flex items-center gap-2 font-semibold"><Award className="h-4 w-4 text-primary" aria-hidden="true" /> Award Winner</p><p className="mt-1 text-sm font-normal text-muted-foreground">Corporate LiveWire Greece</p></div>
        </div>
      </div>
      <div className="home-photo-mosaic" aria-label="From preparing your bag to your next departure">
        <div className="home-photo-column">
          <img src={airport} alt="Traveler with a teal suitcase at an airport departure terminal" width={768} height={1024} fetchPriority="high" className="home-photo-tall" />
          <img src={packing} alt="Open suitcase neatly packed with clothes and a packing cube, a straw sunhat resting beside it" width={1024} height={768} loading="lazy" className="home-photo-short" />
        </div>
        <div className="home-photo-column home-photo-offset">
          <img src={passport} alt="Passport, camera, sunglasses and map laid out before a trip" width={1024} height={768} loading="lazy" className="home-photo-short" />
          <img src={lisbon} alt="Traveler with a teal suitcase walking down a Lisbon cobblestone street toward the river" width={768} height={1024} loading="lazy" className="home-photo-tall" />
        </div>
      </div>
    </section>
  );
};
